module.exports = __webpack_public_path__ + "static/media/gallery-13.69094a8f.JPG";